export const NO_RECORD_FOUND = "NO RECORD FOUND";